import { Injectable } from '@angular/core';
import { AsyncValidator, AbstractControl, ValidationErrors } from '@angular/forms';
import { Store } from '@ngrx/store';
import { getJobsiteSalesArea, OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';

@Injectable()
export class JobsiteCreditBlockValidator implements AsyncValidator {
  constructor(private store: Store<OrderBuilderState>) {}

  /**
   *
   * @param control
   * @returns
   */
  validate(control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return this.store.select(getJobsiteSalesArea).pipe(
      filter(data => !!data && data.length > 0),
      take(1),
      map(jobsiteSalesArea => {
        return !!_safe(() => jobsiteSalesArea[0]['isCreditBlocked']) === false ? null : { hasCreditBlock: true };
      }),
    );
  }
}
